import { ru } from 'date-fns/locale'
import {
	differenceInYears,
	differenceInMonths,
	format,
	formatDuration,
	addMonths,
	isToday,
} from 'date-fns'

const MONTHS = [
	'Январь',
	'Февраль',
	'Март',
	'Апрель',
	'Май',
	'Июнь',
	'Июлю',
	'Август',
	'Сентябрь',
	'Октябрь',
	'Ноябрь',
	'Декабрь',
]

const MONTHSALT = [
	'Январе',
	'Феврале',
	'Марте',
	'Апреле',
	'Мае',
	'Июне',
	'Июле',
	'Августе',
	'Сентябре',
	'Октябре',
	'Ноябре',
	'Декабре',
]

const YEAR = new Date().getFullYear()

export default {
	date(date, formatStr) {
		let d = new Date(date)
		return format(d, formatStr)
	},

	dateToAge(date) {
		let { years, months } = this.ageFromDate(date)
		return formatDuration({ years, months }, { locale: ru })
	},

	ageToDate(years, months) {
		let now = new Date()
		let monthsAdd = years * 12 + months

		return addMonths(now, -monthsAdd)
	},

	ageFromDate(date) {
		let d = new Date(date)
		let now = new Date()
		let years = differenceInYears(now, d)
		let months = differenceInMonths(now, d)
		return { years: years, months: months % 12 }
	},

	formattedDateFromAge(years, months, lower = true, alt) {
		let d = this.ageToDate(years, months)
		let year = d.getFullYear()
		let month = d.getMonth()

		if (alt) {
			month = MONTHSALT[month]
			if (lower) month = month.toLowerCase()
		} else {
			month = MONTHS[month]
			if (lower) month = month.toLowerCase()
		}

		return `${month} ${year}`
	},

	weightToFloat(kg, gr) {
		return parseFloat(`${kg}.${gr}`)
	},

	floatToWeight(float) {
		float += ''
		let [kg, gr] = float.split('.')
		return { kg: parseInt(kg), gr: parseInt(gr) }
	},

	chatDate(date) {
		let form = 'HH:mm dd.MM'
		let d = new Date(date)
		if (isToday(d)) form = 'HH:mm'
		else if (d.getFullYear() !== YEAR) form += '.yyyy'
		return format(new Date(date), form)
	},
}
